/* eslint-disable react/prop-types */

import React from 'react';
import { Description, Image } from '../../components/layouts';
import { buildImageURL, pureTrans } from '../../helpers';
import LazyLoad from 'react-lazyload';

const IMAGE = buildImageURL('/album.jpg');
const VIDEO1 = buildImageURL('/video-album-1.mp4');
const VIDEO2 = buildImageURL('/video-album-2.mp4');

export function DesktopContent({ x }) {
  const [y1, setY1] = React.useState(0);
  const [y2, setY2] = React.useState(0);
  React.useEffect(() => {
    const unsub = x.onChange(() => {
      const _x = x.get();
      setY1(pureTrans(_x, [0, 1], [0, -50], 0));
      setY2(pureTrans(_x, [0, 1], [0, -50], 3));
    });
    return unsub;
  }, [x, setY1, setY2]);
  return (
    <div className="section-content left columns">
      <div className="album">
          {/* <Image loadingType="lazy" src={IMAGE} style={{ transform: `translateY(${y1}%) translateZ(0)` }} /> */}

          <div className="video-box">
            <video className="video" src={VIDEO1} autoPlay={true} loop={true} controls={false} muted={true}/>
          </div>

          <Description>刷新率 60Hz</Description>

      </div>
      <div className="album">
          {/* <Image loadingType="lazy" src={IMAGE} style={{ transform: `translateY(${y2}%) translateZ(0)` }} /> */}
          <div className="video-box">
            <video className="video" src={VIDEO2} autoPlay={true} loop={true} controls={false} muted={true}/>
          </div>
          <Description>刷新率 120Hz</Description>

      </div>
    </div>
  );
}
